import React, { useEffect } from 'react'
import { ContainerRadiology } from './styles'
import { RadiologyContent, RadiologyHeader } from '~/components/radiologyMedicalView'
import { withDashboardLoader } from '~/components/shared'
import { RadiologyHealthProceduresProvider, usePatient } from '~/context'
import { useDocumentTitle, useMaternalInfantViewSettings } from '~/hooks'
import { message } from '~/services'

const RadiologyMedicalViewPage = (): JSX.Element => {
  useDocumentTitle(message('titles.timeline_radiology'))
  const { resetPatientTag } = usePatient()
  const { cleanupMaternalInfantViewSettings } = useMaternalInfantViewSettings()

  useEffect(() => {
    resetPatientTag()
    cleanupMaternalInfantViewSettings()
  }, [resetPatientTag])

  return (
    <RadiologyHealthProceduresProvider>
      <ContainerRadiology>
        <RadiologyHeader />
        <RadiologyContent />
      </ContainerRadiology>
    </RadiologyHealthProceduresProvider>
  )
}

export const RadiologyMedicalView = withDashboardLoader(RadiologyMedicalViewPage)
